import request from '@utils/request'

export function fetchFormList(params) {
  return request({
    url: `/admin/form`,
    params,
  })
}

export function fetchForm(seq) {
  return request({
    url: `/admin/form/${seq || 0}`,
    method: 'get',
  })
}

export function createForm(data) {
  return request.post('/admin/form', data)
}

export function updateForm(data) {
  return request.put(`/admin/form/${data.seq}`, data)
}

export function deleteForm(seq) {
  return request.delete(`/admin/form/${seq}`)
}

export function fetchFields(form_seq) {
  return request({
    url: `/admin/form/${form_seq || 0}/field`,
  })
}

export function fetchField(form_seq, seq) {
  return request({
    url: `/admin/form/${form_seq || 0}/field/${seq || 0}`,
    method: 'get',
  })
}

export function createField({ form_seq, ...data }) {
  return request.post(`/admin/form/${form_seq || 0}/field/`, data)
}

export function updateField({ form_seq, seq, ...data }) {
  return request.put(`/admin/form/${form_seq || 0}/field/${seq}`, data)
}

export function deleteField(form_seq, seq) {
  return request.delete(`/admin/form/${form_seq || 0}/field/${seq}`)
}
